import getUID from '@jetbrains/ring-ui/components/global/get-uid'
import {useMemo} from 'react'

const useUID = (prefix: string): string => useMemo(() => getUID(prefix), [prefix])

export default useUID
